import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TwoFactorAuthComponent } from '../components/two-factor-auth/two-factor-auth.component';
import { UserService } from './user.service';
import { UserStatus } from 'src/app/enums/constants';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class TfaService {

  constructor(
    private matDialog: MatDialog,
    private userService: UserService,
    private authService: AuthService,
  ) { }

  isTFAValid() {
    return this.userService.user.tfaSuccess === true;
  }

  isTFANecessary() {
    if (!this.userService.user.tfaSuccess) {
      this.sendTFA();
    }
  }

  sendTFA() {
    const self = this;
    this.userService.sendLoggedInUserTFA({
      getResult(result) {
        self.tfaModal();
      },
      getError(err) {
        if(err.error?.userStatus === UserStatus.LOCKED_INVALID_TFA) {
          self.authService.doLogout(true);
        } else {
          self.tfaModal();
        }
      },
    });
  }

  tfaModal() {
    const dialogRef = this.matDialog.open(TwoFactorAuthComponent, {
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((value) => {
      if (value && value.add) {
        const dataToAdd = value.data;
      }
    });
  }
}
